export default {
  props: {
    value: {}
  },
  componentName: 'BaseTabs',
  data: function data() {
    return {};
  },
  watch: {
    value: function value(nowValue, oldValue) {
      if (nowValue !== oldValue) {
        this.$emit('change', nowValue);
      }
    }
  }
};